/**
 * views-public.js
 * ---------------
 * front-end javascript for VIEWS
 * by Philip Kuperberg
 */

// import "core-js/stable";
// import "regenerator-runtime/runtime";

import { setupRoutingEvents } from './src/routing';
import { setupCountdownEvents } from './src/countdowns';
import { initMap } from './src/gmaps';
import { setupModalEvents, launchModalWithContent } from './src/modals';
import { setupSliders } from './src/sliders';
import { scrollTo, setupScrollEvents, contentOffset } from './src/scrolling';
import { preload } from './src/preload';
import "./agenda-filters";

// import { setupMenuEvents } from '%/menus';
// import { setupAgendaEvents } from '%/agendas';
// import { setupGlobalEvents } from '%/global';
// import { setupGAEvents } from '%/ga-events';
// import { moduleRouter } from './src/module-router';

// import "../scss/style-patch.scss";


const $ = jQuery.noConflict();

let htmlClasses = document.documentElement.className;
if (htmlClasses.indexOf('evtx-page') >= 0){

   window.scrollTop = 0;

   setupRoutingEvents();
   setupModalEvents();
   // setupMenuEvents();
   // setupAgendaEvents();
   // setupGlobalEvents();
   // setupScrollEvents();
   setupCountdownEvents();
   // setupGAEvents();
   setupSliders();

   // if (window._moduleJs){
   //    moduleRouter(_moduleJs);
   // }

   window._views = {

      /**
		 * SPEED constant used in various view transition effects
		 * @type {Integer} Transition time in milliseconds
		 */
      SPEED: 200,

      /**
		 * Checks for fixed position menus and returns the distance
		 * to the readable portion of the document.
		 * Useful for searching/scrolling operations.
		 * @return {integer} Distance from top of browser to readable portion.
		 */
      contentOffset,

      /**
		 * Scrolls to a pixel location on page
		 * @param  {integer} location  pixel destination in document
		 * @param  {integer} scrollTime  ms to reach destination
		 * @return {undefined}
		 */
      scrollTo,

      /**
		 * Callback fired from Google Maps API script tag
		 * @return {undefined}
		 */
      initMap,

      preload

      
   };

   // Download Google Maps Script
   // $(document).ready(function(){
   //    if (window.mapScriptUrl){
   //       $.getScript(mapScriptUrl);
   //    }
   // });

   // console debug messages
   // if (!PRODUCTION){
   //    if (typeof _consoleDebugs !== "undefined" && _consoleDebugs.length){
   //       for (let c of _consoleDebugs){
   //          console.log(c.label, c.var);
   //       }
   //    }
   // }

   $('.image-pop').on('click', function() {
      const fullSrc = this.getAttribute('data-image-full');
      const modalEl = document.getElementById('evtx-modal');
      let caption = this.getAttribute('data-caption');
      if (caption) {
         caption = `<figcaption>${caption}</figcaption>`;
      }

      if (fullSrc) {
         modalEl.classList.add('evtx-image-modal');
         launchModalWithContent(
            `<div class="modal-image">
               <img src="${fullSrc}" />
               ${caption}
            </div>
            `
         );
      }
      modalEl.addEventListener('hidden.bs.modal', function() {
         modalEl.classList.remove('evtx-image-modal');
      })
   });

}



